import { getStickyAction } from 'automaton/actions/StickyAction'
import { getFreespinEndState } from 'automaton/states/FreespinsEndState'
import { getFreespinsSpinState } from 'automaton/states/FreespinsSpinState'
import { getFreespinsWinState } from 'automaton/states/FreespinsWinState'

export function getStickyState() {
  const freespinModel = game.models.FreespinModel.get()
  const winModel = game.models.WinModel.get()
  const name = 'Sticky'
  const actions = [getStickyAction()]

  const transition = () => winModel.winLines.length ? getFreespinsWinState() : freespinModel.left ? getFreespinsSpinState() : getFreespinEndState()

  return {
    name,
    actions,
    transition,
  }
}
